import { RouteConfig } from 'vue-router';

export function procedureDataRoute(name: string): RouteConfig {
  return {
    path: 'data',
    name,
    component: () => import(/* webpackChunkName: "ProcedureData" */ '@/views/mainRoute/procedure/steps/Data.vue'),
    meta: {}
  };
}
